import { render, staticRenderFns } from "./PositionCell.vue?vue&type=template&id=840dfb0a&scoped=true&"
import script from "./PositionCell.vue?vue&type=script&lang=js&"
export * from "./PositionCell.vue?vue&type=script&lang=js&"
import style0 from "./PositionCell.vue?vue&type=style&index=0&id=840dfb0a&lang=less&scoped=true&"
import style1 from "./PositionCell.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840dfb0a",
  null
  
)

export default component.exports